import React from "react";

import { Container, Sessao, Wrapper } from "./styles";
import NoticiaCard from "../../../NoticiaCard/Basico";

function LatestNewsSession(props) {
  const noticias = props.noticias;
  const [qntNoticias, setQntNoticias] = React.useState(6);
  const [arrayNoticias, setArrayNoticias] = React.useState(
    noticias?.slice(0, 8)
  );

  React.useEffect(() => {
    setArrayNoticias(noticias.slice(0, qntNoticias));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [qntNoticias, props.noticias]);
  return (
    <Sessao>
      <Container>
        <p>Noticias mais recentes</p>
        <Wrapper>
          {noticias.length > 0 ? (
            arrayNoticias.map((noticia) => {
              return (
                <NoticiaCard
                  imgUrl={noticia.noticia_img_path}
                  titulo={noticia.titulo}
                  tagCategoria={noticia.categorias}
                  textPrevia={noticia.previa_texto}
                  data={noticia.data_de_publicacao}
                  toUrl={`/noticias/${noticia.id}`}
                />
              );
            })
          ) : (
            <>Sem notícias cadastradas</>
          )}
        </Wrapper>
        {noticias.length > qntNoticias ? (
          <button
            onClick={() => {
              setQntNoticias(qntNoticias + 6);
            }}
          >
            Carregar mais notícias
          </button>
        ) : (
          <></>
        )}
      </Container>
    </Sessao>
  );
}

export default LatestNewsSession;
